/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { getConfig } from 'blb-utils/config';
import * as Sentry from '@sentry/browser';
export let ERROR = /*#__PURE__*/function (ERROR) {
  ERROR["DOWNLOADING_FILE"] = "Something went wrong downloading your file.";
  ERROR["ERROR_COMPLETING_TAGGING"] = "Looks like we hit a snag while completing tagging.";
  ERROR["FETCHING_DASHBOARD"] = "Looks like we hit a snag fetching your dashboard.";
  ERROR["FETCHING_CLOSING_NOT_FOUND"] = "A closing was not found for this loan. Please contact the lender for further information.";
  ERROR["FETCHING_PIPELINE"] = "Looks like we hit a snag fetching your pipeline.";
  ERROR["GENERATING_REPORT"] = "Report generation failed due to an issue.";
  ERROR["INVITE_USER"] = "There was a problem inviting user.";
  ERROR["LOADING_PAGE"] = "There was a problem loading the page.";
  ERROR["LOGGING_IN"] = "There was a problem logging into your account.";
  ERROR["PAGE_NOT_PERMITTED"] = "Looks like you do not have permissions to access this page.";
  ERROR["REDIRECTING_DOCUSIGN"] = "Something went wrong redirecting to DocuSign.";
  ERROR["REDIRECTING_ERROR"] = "Something went wrong redirecting to a new URL.";
  ERROR["REPORT_HAS_NO_DATA"] = "There is no available data in report for the time frame.";
  ERROR["SAVING_ADDRESS"] = "There was an error saving your address.";
  ERROR["SAVING_INFO"] = "There was an error saving your information.";
  ERROR["SENDING_FORM"] = "Looks like we hit a snag sending your information.";
  ERROR["SENDING_MESSAGE"] = "There was an error sending this message.";
  ERROR["UPDATE_NOTARY_STATUS"] = "There was an error updating notary status.";
  ERROR["UPLOADING_DOCUMENTS"] = "Something went wrong uploading your documents.";
  return ERROR;
}({});
export let SPECIFIC_ERROR_TYPES = /*#__PURE__*/function (SPECIFIC_ERROR_TYPES) {
  SPECIFIC_ERROR_TYPES["FETCHING_CLOSING_NO_ACCESS"] = "FETCHING_CLOSING_NO_ACCESS";
  return SPECIFIC_ERROR_TYPES;
}({});
const getSpecificErrorMessage = (type, opts) => {
  switch (type) {
    case SPECIFIC_ERROR_TYPES.FETCHING_CLOSING_NO_ACCESS:
      return `You (${opts?.userEmail}) are not authorized to access this closing. Please ensure that you are logged in with the correct account or contact your lender to request access.`;
    default:
      return '';
  }
};
export const errorMessage = function (type) {
  let principalType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  let referSupport = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let specificErrorOpts = arguments.length > 3 ? arguments[3] : undefined;
  const {
    supportEmail
  } = getConfig();
  let message;
  if (specificErrorOpts) {
    message = getSpecificErrorMessage(type, specificErrorOpts);
  } else {
    const referSupportAddOn = referSupport ? ` Please try again later or reach out to ${supportEmail[principalType]}.` : '';
    message = `${ERROR[type]}${referSupportAddOn}`;
  }
  Sentry.captureException(message);
  return message;
};